import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'NewPasswordInput' })({
  input: {
    background: 'initial',
    backgroundColor: 'white',
  },
});
